export default __webpack_public_path__ + "deviceFarmHighLevelArch.6acab6e2.png";